import { Link } from "react-router-dom";
import { ExternalLink, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CONTACT } from "@/constants/contact";
import { IMAGES } from "@/constants/images";

const priceGroups = [
  {
    title: "Montage pneumatique",
    testid: "pneus-montage-card",
    rows: [
      ["Jante tôle", "15,90 €"],
      ["Jante alu", "17,90 €"],
      ["4x4", "19,90 €"],
      ["Camionnette et utilitaire", "19,90 €"],
      ["Camping-car", "22,90 €"],
    ],
  },
  {
    title: "Autres prestations",
    testid: "pneus-autres-card",
    rows: [
      ["Équilibrage seul", "7,90 €"],
      ["Permutation", "20,00 €"],
      ["Réparation crevaison", "15,00 €"],
      ["Dépose + pose roues complètes (2 roues)", "10,00 €"],
      ["Dépose + pose roues complètes (4 roues)", "20,00 €"],
    ],
  },
  {
    title: "Montage quad",
    testid: "pneus-quad-card",
    rows: [["Quad", "10,00 €"]],
  },
];

export default function PneusPage() {
  return (
    <div data-testid="pneus-page">
      <PageHero
        image={IMAGES.pneus}
        imageAlt="Montage d'un pneu sur jante aluminium"
        imageTestid="pneus-bg-image"
        eyebrow="Pneus"
        title="Montage pneumatique à Pont-d'Ain"
      >
        Montage, équilibrage, permutation et réparation de crevaison :
        découvrez nos tarifs et prenez rendez-vous avec le garage.
      </PageHero>

      <section className="border-t border-border">
        <div className="mx-auto grid max-w-6xl gap-6 px-4 py-20 lg:grid-cols-3">
          {priceGroups.map((group, i) => (
            <Reveal key={group.title} delay={i * 0.08}>
              <article
                data-testid={group.testid}
                className="flex h-full flex-col rounded-lg border border-border bg-card p-6 transition-colors card-lift hover:border-primary/50"
              >
                <h2 className="font-display text-xl font-semibold uppercase">
                  {group.title}
                </h2>
                <ul className="mt-6 flex-1 divide-y divide-border">
                  {group.rows.map(([label, price]) => (
                    <li key={label} className="flex items-center justify-between gap-4 py-3 text-sm">
                      <span className="text-muted-foreground">{label}</span>
                      <span className="font-display text-lg font-semibold text-primary">{price}</span>
                    </li>
                  ))}
                </ul>
                <Button asChild className="mt-6" data-testid={`${group.testid}-cta`}>
                  <a href={CONTACT.phoneHref}>
                    <Phone className="mr-2 h-4 w-4" /> Prendre rendez-vous
                  </a>
                </Button>
              </article>
            </Reveal>
          ))}
        </div>
        <div className="mx-auto max-w-6xl px-4 pb-16">
          <Reveal>
            <div
              data-testid="centralepneus-partner-card"
              className="flex flex-col items-center gap-6 rounded-lg border border-border bg-card p-6 sm:flex-row sm:p-8"
            >
              <a
                href={CONTACT.centralepneusLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="centralepneus-image-link"
                className="shrink-0"
              >
                <img
                  src="/images/centralepneus.jpg"
                  alt="Station montage partenaire Centralepneus.fr"
                  className="h-44 w-auto rounded-md"
                />
              </a>
              <div>
                <p className="text-sm font-semibold uppercase tracking-[0.25em] text-primary">
                  Partenaire
                </p>
                <h2 className="mt-2 font-display text-2xl font-bold uppercase">
                  Station de montage partenaire Centralepneus.fr
                </h2>
                <p className="mt-3 text-sm text-muted-foreground">
                  Commandez vos pneus en ligne sur Centralepneus.fr et faites-les
                  monter directement dans notre garage à Pont-d'Ain.
                </p>
                <Button asChild className="mt-5" data-testid="centralepneus-cta-button">
                  <a href={CONTACT.centralepneusLink} target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" /> Accéder au site Centralepneus.fr
                  </a>
                </Button>
              </div>
            </div>
          </Reveal>
        </div>
        <div className="mx-auto max-w-6xl px-4 pb-20">
          <p className="text-sm text-muted-foreground">
            Tarifs hors fourniture des pneumatiques. Une question sur une
            prestation ?{" "}
            <Link to="/#contact" data-testid="pneus-contact-link" className="text-primary underline-offset-4 hover:underline">
              Contactez le garage
            </Link>
            .
          </p>
        </div>
      </section>
    </div>
  );
}
